export default __webpack_public_path__ + "static/media/catalogo.3b0c66f9.png";